The candidate's availability for a new position.

This is only available for Apply with SEEK candidate profiles.
For candidate applications, uploaded candidate profiles & purchased profiles this will be `null`.
